import { base_url } from 'Constants';
import { CKEditor } from 'ckeditor4-react';
import React, { useState, useEffect, useRef } from 'react';

const editorUrl = `${base_url}/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js`;

const editorConfig = {
  toolbar: [
    // { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
    // { name: "paragraph", items: ["NumberedList", "BulletedList"] },
    // // { name: "insert", items: ["Image", "Table"] },
    // { name: "document", items: ["Source"] },
  ],
  width: "100%",
  allowedContent: true,
  removePlugins: "exportpdf",
};

const CustomCKEditor = ({ name, onChange, value }) => {
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState(value || "");

  // 🔹 Update CKEditor content if parent value changes
  useEffect(() => {
    if (editorRef.current && value !== editorContent) {
      editorRef.current.setData(value);
      // console.log(value);
    }
  }, [value]);

  const handleEditorChange = (event) => {
    const data = event.editor.getData();
    setEditorContent(data);
    if (onChange) onChange(data);
  };

  return (
    <div>
      <CKEditor
        name={name}
        initData={editorContent}
        config={editorConfig}
        editorUrl={editorUrl}
        onChange={handleEditorChange}
        onInstanceReady={(event) => {
          editorRef.current = event.editor;
        }}
      />
      <input name={name} type="hidden" value={editorContent} readOnly />
    </div>
  );
};

export default CustomCKEditor;
